import { Button } from '@mui/material'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import request from '../../config/request'
import { controlLoading } from '../../store/actions/loadingActions'
import { getErrors } from '../../store/actions/errorActions'

const ProductColorDownload = () => {
    const dispatch = useDispatch()
    const { userToken } = useSelector((state) => state.auth)

    const download = useCallback(async () => {
        try {
            dispatch(controlLoading(true))

            const res = await request.get('productcolor/download-all', {
                headers: { Authorization: `Bearer ${userToken}` },
            })

            const allItems = res.data.data || []

            const maxItems = Math.max(
                0,
                ...allItems.map((p) => p.productitems?.length || 0)
            )

            const baseHeaders = [
                'ID',
                'Product Color SKU',
                'MSRP',
                'Online',
                'Adjustment',
                'Adjustment Type',
                'Adjustment Amount',
            ]

            const itemHeaders = Array.from({ length: maxItems }).flatMap(
                (_, i) => [
                    `Item ${i + 1} SKU`,
                    `Item ${i + 1} Qty`,
                    `Item ${i + 1} Unit Price`,
                    `Item ${i + 1} Stock`,
                ]
            )

            const header = [...baseHeaders, ...itemHeaders]

            const formattedData = allItems.map((productColor) => {
                const row = {
                    ID: productColor.id,
                    'Product Color SKU': productColor.skuNo,
                    MSRP: productColor.MSRPinCAD,
                    Online: productColor.online ? 'Yes' : '',
                    Adjustment: productColor.adjustment ? 'Yes' : '',
                    'Adjustment Type': productColor.adjustment
                        ? productColor.adjustmentType === 1
                            ? 'INCREASE'
                            : 'DECREASE'
                        : '',
                    'Adjustment Amount': productColor.adjustment
                        ? productColor.adjustmentAmount
                        : '',
                }

                productColor.productitems?.forEach((pi, index) => {
                    row[`Item ${index + 1} SKU`] = pi.item?.itemSKU || ''
                    row[`Item ${index + 1} Qty`] = pi.quantity ?? ''
                    row[`Item ${index + 1} Unit Price`] =
                        pi.item?.MSRPinCAD ?? ''
                    row[`Item ${index + 1} Stock`] = pi.item?.stock ?? ''
                })

                return row
            })

            const worksheet = XLSX.utils.json_to_sheet(formattedData, {
                header,
            })

            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, worksheet, 'productColors')

            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array',
            })

            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })

            saveAs(blob, `ProductColors_${Date.now()}.xlsx`)
            dispatch(controlLoading(false))
        } catch (e) {
            dispatch(getErrors('Download Product Colors details error'))
            dispatch(controlLoading(false))
        }
    }, [dispatch, userToken])

    return (
        <Button
            color="success"
            variant="outlined"
            onClick={() => download()}
            style={{ marginTop: '10px', marginBottom: '10px' }}
        >
            Download Product Color
        </Button>
    )
}

export default ProductColorDownload
